import React from "react";
import Star from "../SvgIcons/Star";

const RatingBar = ({ totalRating, rating }) => {
  const ratingPercent = Math.round((rating / totalRating) * 100);
  return (
    <div className="flex items-center justify-end">
      <div className="flex mr-4">
        <Star className="w-5 h-5 fill-yellow" />
        <Star className="w-5 h-5" />
        <Star className="w-5 h-5" />
        <Star className="w-5 h-5" />
        <Star className="w-5 h-5" />
      </div>
      <div className="h-3 w-32 bg-ratingBar mr-3">
        <div className={`h-3 bg-yellow w-[${ratingPercent}%]`}></div>
      </div>
      <span className="font-pop text-[11px] text-ratingText">
        {rating || 32}
      </span>
    </div>
  );
};

export default RatingBar;
